import React, { useMemo } from "react";
import { Paper, Typography, Stack, Box, Chip } from "@mui/material";

import { mockConversations } from "../../../mocks/mockConversations";

function buildAlerts(conversations) {
    // heurísticas simples (mock) — depois plugamos no Firebase real
    const total = Array.isArray(conversations) ? conversations.length : 0;

    const semResposta = (conversations || []).filter((c) => c?.needsReply).length;
    const aguardandoAgendamento = (conversations || []).filter(
        (c) => c?.flags?.readyForScheduling
    ).length;

    const altaPrioridade = (conversations || []).filter(
        (c) => c?.priority === "alta"
    ).length;

    const alerts = [];

    if (semResposta > 0) {
        alerts.push({
            title: "Leads sem resposta",
            value: semResposta,
            tag: "Responder",
        });
    }

    if (aguardandoAgendamento > 0) {
        alerts.push({
            title: "Prontos para agendar",
            value: aguardandoAgendamento,
            tag: "Agendar",
        });
    }

    if (altaPrioridade > 0) {
        alerts.push({
            title: "Alta prioridade",
            value: altaPrioridade,
            tag: "Urgente",
        });
    }

    if (alerts.length === 0) {
        alerts.push({
            title: "Tudo em dia",
            value: "OK",
            tag: "🎉",
        });
    }

    return { total, alerts };
}

export default function AlertsPanel() {
    const { total, alerts } = useMemo(
        () => buildAlerts(mockConversations),
        []
    );

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                border: "1px solid var(--border)",
                background: "var(--branco)",
            }}
        >
            <Typography sx={{ fontWeight: 800, color: "var(--cise-blue)", mb: 0.5 }}>
                Alertas
            </Typography>

            <Typography sx={{ fontSize: 13, color: "var(--cise-text-muted)", mb: 2 }}>
                Monitoramento rápido da operação ({total} conversas)
            </Typography>

            <Stack spacing={1.2}>
                {alerts.map((a, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            p: 1.2,
                            borderRadius: 2,
                            border: "1px solid var(--border)",
                            background: "var(--branco)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 800, fontSize: 13 }} noWrap>
                                {a.title}
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: "var(--cise-text-muted)" }}>
                                {typeof a.value === "number" ? `${a.value} itens` : a.value}
                            </Typography>
                        </Box>

                        <Chip
                            label={a.tag}
                            size="small"
                            sx={{
                                fontWeight: 800,
                                background: "rgba(0, 122, 255, 0.12)",
                                color: "var(--cise-blue)",
                                border: "1px solid rgba(0, 122, 255, 0.2)",
                            }}
                        />
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
}